module.exports = __webpack_public_path__ + "static/img/appStore.c4612cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/appStore.svg
// module id = zDxL
// module chunks = 1